import * as constants from '../constants';

const initialState = false;

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getDeterminantTypes.try: {
            return true;
        }

        case constants.getDeterminantTypes.success:
        case constants.getDeterminantTypes.error: {
            return false;
        }

        default:
            return false;
    }
}